/** Client profile sections gated by practice enabled verticals (and optional client track). */

export const MSK_FIELD_KEYS = [
  "primary_diagnosis",
  "affected_region",
  "vas_baseline",
  "referral_bilet_msk",
]

export function sectionVisible(section, enabledVerticals, clientTrack) {
  if (section.always) return true
  const enabled = new Set(enabledVerticals || [])
  const verticals = section.verticals || []
  const visibleByPractice = verticals.some((v) => enabled.has(v))
  if (!visibleByPractice) return false
  if (!clientTrack) return true
  return verticals.includes(clientTrack)
}

export function visibleSections(enabledVerticals, clientTrack) {
  return CLIENT_PROFILE_SECTIONS.filter((s) =>
    sectionVisible(s, enabledVerticals, clientTrack)
  )
}

export const CLIENT_PROFILE_SECTIONS = [
  { id: "core", always: true },
  { id: "cnas", verticals: ["physio", "kineto", "psych", "speech", "nutrition"] },
  { id: "psych_assessments", verticals: ["psych"] },
  { id: "msk_clinical", verticals: ["physio", "kineto"] },
  { id: "speech_track", verticals: ["speech"] },
]

export function readMskFields(customFields) {
  const cf = customFields && typeof customFields === "object" ? customFields : {}
  return {
    primary_diagnosis: String(cf.primary_diagnosis ?? ""),
    affected_region: String(cf.affected_region ?? ""),
    vas_baseline: String(cf.vas_baseline ?? ""),
    referral_bilet_msk: String(cf.referral_bilet_msk ?? cf.referral_bilet ?? ""),
  }
}

export function readClientTrack(customFields) {
  const cf = customFields && typeof customFields === "object" ? customFields : {}
  return String(cf.primary_vertical ?? cf.client_track ?? "").trim() || null
}
